import { ReactNode } from "react"
import styled, { DefaultTheme } from "styled-components"
import { Typography } from "../../typography"

export type BadgeVariant = "primary" | "secondary" | "warning" | "info" | "danger" | "disabled" | "marketing"

function getVariantColor(theme: DefaultTheme, $badgeVariant?: BadgeVariant) {
  switch ($badgeVariant) {
    case "primary":
      return theme.colors.primary.$300
    case "secondary":
      return theme.colors.secondary.$300
    case "warning":
      return theme.colors.warning.$300
    case "info":
      return theme.colors.info.$300
    case "danger":
      return theme.colors.danger.$200
    case "disabled":
      return theme.colors.grey.$600
    case "marketing":
      return theme.colors.white
    default:
      return theme.colors.primary.$300
  }
}

function getVariantBackgroundColor(theme: DefaultTheme, $badgeVariant?: BadgeVariant) {
  switch ($badgeVariant) {
    case "primary":
      return theme.colors.primary.$100
    case "secondary":
      return theme.colors.secondary.$100
    case "warning":
      return theme.colors.warning.$100
    case "info":
      return theme.colors.info.$100
    case "danger":
      return theme.colors.danger.$100
    case "disabled":
      return theme.colors.grey.$100
    case "marketing":
      return `linear-gradient(93.5deg, #b183f2 0%, #ffb571 50%, #9effad 100%);`
    default:
      return theme.colors.primary.$100
  }
}

const BadgeContent = styled(Typography).attrs<{
  $badgeVariant?: BadgeVariant
}>(({ $badgeVariant, as }) => ({
  $badgerVariant: $badgeVariant ?? "primary",
  $variant: "caption-1",
  as: as ?? "span",
}))`
  height: 2rem;

  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.75rem;
  border-radius: 8.125rem;

  white-space: nowrap;

  color: ${({ theme, $badgeVariant }) => getVariantColor(theme, $badgeVariant)};
  background: ${({ theme, $badgeVariant }) => getVariantBackgroundColor(theme, $badgeVariant)};

  & svg {
    height: 1rem;
  }
`

type BadgeProps = {
  $variant?: BadgeVariant
  icon?: ReactNode
  children: ReactNode
  as?: React.ElementType
  title?: string
}

export const DeprecatedBadge: React.FC<BadgeProps> = ({ $variant, icon, children, title, as, ...rest }) => (
  <BadgeContent $badgeVariant={$variant} as={as} title={title} {...rest}>
    {children}
    {icon}
  </BadgeContent>
)
